import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../Components/Tabs';
import ManageUsersScreen from './ManageUsers';
import ManageTeamsScreen from './ManageTeams';
import ManageGroupsScreen from './ManageGroups';
import TeamsUsersManagementController from '../../../Controllers/AdminManagementScreens/TeamsAndUsers/TeamsUsersManagementController';


const TeamsUsersManagementScreen = () => {

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);
    const [disabledTabs, setDisabledTabs] = useState([]);

    const{
        teamList,
        error,
        loading,
        refreshTeamList,
        userList,
        userError,
        userLoading,
        refreshUserList
    }=TeamsUsersManagementController();

    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
        const { per_name_sub_json } = storedUserInfo?.user_permissions?.emp_mgmt || {};

        const manageEmpDisabled = per_name_sub_json?.manage_emp_add_edit_emp === 0;
        const manageTeamDisabled = per_name_sub_json?.manage_teams_add_edit_emp === 0;

        const disabledTabIndices = [];
        if (manageEmpDisabled) disabledTabIndices.push(0);
        if (manageTeamDisabled) disabledTabIndices.push(1);

        setDisabledTabs(disabledTabIndices);
        if (disabledTabIndices.includes(selectedTab)) {
            // setSelectedTab(0);
            // opened enabled tab as first tab in the enabled tabs list
            const firstEnabledTab = [0, 1].find(tab => !disabledTabIndices.includes(tab));
            setSelectedTab(firstEnabledTab ?? 0);
        }

    },[selectedTab])

    const handleTabChange = (index) => {
        if (disabledTabs.includes(index)) return;
        setSelectedTab(index);
    };

    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{paddingBottom:20}}>
                <h2 className='title'>Add/Edit Employees</h2>
            </div>

            <div >
                {/* <Tabs tabs={['Manage Employee','Manage Teams']}> */}
                <Tabs
                    tabs={['Manage Employee', 'Manage Teams']}
                    selectedIndex={selectedTab}
                    onTabChange={handleTabChange}
                    divBorder={false}
                    disabledTabs={disabledTabs}
                >
                    {selectedTab === 0 && !disabledTabs.includes(0) && <ManageUsersScreen userList={userList} error={userError} loading={userLoading} onRefresh={refreshUserList} refreshTeamList={refreshTeamList}/> }
                    {selectedTab === 1 && !disabledTabs.includes(1) && <ManageTeamsScreen teamList={teamList} error={error} loading={loading} onRefresh={refreshTeamList}/> }
                    {/* <ManageGroupsScreen /> */}
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default TeamsUsersManagementScreen;